import { scenarioGraphTypes } from 'components/scenarios/utils/graph'
import { State } from 'types/api'
import { EndpointConfiguration } from 'types/api/end-point'
import { ScenarioRunGraph } from 'types/api/gamedays/scenarios'
import { EvaluationConfiguration } from 'types/api/services/evaluation'

export enum Lifecycle {
  NotStarted = 'NotStarted',
  Active = 'Active',
  HaltRequested = 'HaltRequested',
  Successful = 'Successful',
  Halted = 'Halted',
  Failed = 'Failed',
  UserHalted = 'UserHalted'
}

export interface GraphNode {
  type?: Type
  id?: string
  state?: State
  lifecycle?: Lifecycle
  startTime?: Date
  endTime?: Date
  expectedLengthInSeconds?: number
  expectedLengthIncludingDelaysInSeconds?: number
  initialState?: State
  expectedSecondsRemaining?: number
  updateIntervalInSeconds?: number
  next?: string
  branches?: ScenarioRunGraph[]
  name?: string
  isHaltable: boolean
}

export enum Type {
  Concurrent = 'Concurrent',
  Delay = 'Delay',
  InfraAttack = 'InfraAttack',
  ContinuousStatusCheck = 'ContinuousStatusCheck',
  SynchronousStatusCheck = 'SynchronousStatusCheck'
}

export interface ScenarioGraph {
  nodes?: { [key: string]: GraphNode }
  startId?: string
  start?: GraphNode
  expectedLengthWithDelays?: number
  expectedLength?: number
  attackTypeQuantity?: { [key: string]: number }
}

export interface ScenarioInput {
  name?: string
  description?: string
  hypothesis?: string
  steps?: Array<{ [key: string]: any }>
  graph?: ScenarioGraph
  recommendedScenarioId?: string
}

export interface ScenarioResponse {
  orgId?: string
  guid?: string
  name?: string
  description?: string
  hypothesis?: string
  steps?: Array<{ [key: string]: any }>
  graph?: ScenarioGraph
  state?: string
  createSource?: string
  createdBy?: string
  createdAt?: string
  updatedAt?: string
  lastRunAt?: string
  tiers?: string[]
  recommendedScenarioId?: string
}

export interface StatusCheckCreateRequest {
  isContinuous?: boolean
  isPrivateNetwork?: boolean
  name: string
  description?: string
  thirdPartyPresets?: string
  endpointConfiguration: EndpointConfiguration
  evaluationConfiguration: EvaluationConfiguration
  teamExternalIntegration?: StatusCheckTeamExternalIntegration
  webhookId?: string
  rawEndpointConfiguration: EndpointConfiguration
}

export interface StatusCheck {
  createdAt: string
  createdBy: string
  endpointConfiguration: EndpointConfiguration
  evaluationConfiguration: EvaluationConfiguration
  identifier: string
  isContinuous: boolean
  isPrivateNetwork: boolean
  name: string
  teamExternalIntegration: StatusCheckTeamExternalIntegration
  teamId: string
  thirdPartyPresets: string
  type?: scenarioGraphTypes
}

export interface StatusCheckTeamExternalIntegration {
  name: string
  type: string
}

enum Type {
  Concurrent,
  ContinuousStatusCheck,
  Delay,
  InfraAttack,
  SynchronousStatusCheck,
  Continuous
}

export interface StatusCheckNode {
  type: Type
  id: string
  next: string
  name: string
  description: string
  thirdPartyPresets: string
  endpointConfiguration: EndpointConfiguration
  evaluationConfiguration: EvaluationConfiguration
  statusCheckId: string
  statusCheckReferenceId: string
  isPrivateNetwork: boolean
}
